import { create } from 'zustand';

export type ScoreType =
  | 'composite'
  | 'rent_gap'
  | 'mobi'
  | 'momentum'
  | 'vacancy'
  | 'valuation'
  | 'permit'
  | 'spillover';

interface SubmarketState {
  selectedScoreType: ScoreType;
  setSelectedScoreType: (scoreType: ScoreType) => void;
  selectedSubmarketId: number | null;
  setSelectedSubmarketId: (id: number | null) => void;
  highlightedSubmarketId: string | null;
  setHighlightedSubmarketId: (id: string | null) => void;
  isDetailPanelOpen: boolean;
  setDetailPanelOpen: (open: boolean) => void;
  isMethodologyExpanded: boolean;
  setMethodologyExpanded: (expanded: boolean) => void;
}

export const useSubmarketStore = create<SubmarketState>((set) => ({
  selectedScoreType: 'composite',
  setSelectedScoreType: (scoreType) => set({ selectedScoreType: scoreType }),
  selectedSubmarketId: null,
  setSelectedSubmarketId: (id) =>
    set({
      selectedSubmarketId: id,
      isDetailPanelOpen: id !== null,
    }),
  highlightedSubmarketId: null,
  setHighlightedSubmarketId: (id) => set({ highlightedSubmarketId: id }),
  isDetailPanelOpen: false,
  setDetailPanelOpen: (open) =>
    set({
      isDetailPanelOpen: open,
      selectedSubmarketId: open ? undefined : null,
    }),
  isMethodologyExpanded: false,
  setMethodologyExpanded: (expanded) => set({ isMethodologyExpanded: expanded }),
}));

export default useSubmarketStore;
